import ForwardTracker from "../../../../../prop-trackers/forward-tracker.js";
import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../../prop-tracker-utils/mapper.js";
import SinglePropDeepTracker from "../../../../../prop-tracker-utils/single-prop-deep-tracker.js";

class EulerToQuatGenerator extends ForwardTracker {
    constructor(eulerTracker, wrapCtx, evtCtx) {
        const mapper = new Mapper(eulerTracker, (key) => new ObjectQuatMapper(wrapCtx, evtCtx));
        super(mapper);
    }
}

const euler = new THREE.Euler();
const quat = new THREE.Quaternion();

class ObjectQuatMapper extends ValueMapper {
    constructor(wrapCtx, evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._output = wrapCtx.getWrapper({ quaternion: {} });

        this._eulerTracker = new SinglePropDeepTracker(evtCtx);
        this._outputTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._eulerTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(allCoords) {
        if (allCoords) {
            this._eulerTracker.track(allCoords, this._evtCtx.getEvents(allCoords), "rotation");
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._eulerTracker.track();
    }

    protected_startUpdate() {
        this._eulerTracker.update(({ prop: { newValue: eulerData } }) => {
            if (eulerData) {
                {
                    const { x, y, z, order } = eulerData;
                    euler.set(x || 0, y || 0, z || 0, order || "XYZ");
                }

                quat.setFromEuler(euler);

                {
                    const { x, y, z, w } = quat;

                    const quatData = this._output.quaternion;
                    quatData.x = x;
                    quatData.y = y;
                    quatData.z = z;
                    quatData.w = w;
                }

                this._outputTracker.setValue(this._output);
            } else {
                this._outputTracker.deleteValue();
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default EulerToQuatGenerator;
